import styled from 'styled-components/macro';
import { mediaDesktop } from '../../breakpoints';
import Typography from '../Typography';

export const TextUnderCardWrapper = styled.div`
  display: none;

  ${mediaDesktop} {
    margin-top: 32px;
    margin-bottom: 7px;
    padding: 0 24px;
    display: block;
  }
`;
export const StyledText = styled(Typography)`

  ${mediaDesktop} {
    line-height: 19px;
  }
`;
export const StyledPrice = styled(Typography)`
  ${mediaDesktop} {
    line-height: 29px;
    padding: 8px 0;
    font-size: 24px;
    letter-spacing: 1px;
  }
`;
export const StyledNoListings = styled(StyledPrice)`
  padding-top: 0;
`;

export const ForSaleWrapper = styled.div`
  padding: 2px 8px 2px;
  background-color: #ffdc00;
  font: 600 16px ${({ theme }) => theme.fonts.gibson};
  letter-spacing: 2px;
  color: #000000;
  text-align: center;
  text-transform: uppercase;
  width: 115px;

  ${mediaDesktop} {
    width: auto;
    display: inline-block;
  }
`;

export const ListingWrapper = styled.div`
  text-align: start;
  padding-left: 16px;

  ${mediaDesktop} {
    padding-left: 0;
  }
`;
